import React from "react";

const Tabs = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M.563 11.813 2.13 6.588a.56.56 0 0 1 .542-.4h5.913a.56.56 0 0 1 .539.4l1.563 5.225m.563-5.625h.707a.56.56 0 0 1 .538.4l1.568 5.225m.562-5.625h.707a.56.56 0 0 1 .538.4l1.568 5.225m-16.875 0h16.875"
      stroke="#3B3B3B"
      stroke-width="1.125"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export default Tabs;
